// $(function() {
//     $('.Transactions--most_recent > .Transactions-container').flickity({
//         contain: true,
//         imagesLoaded: true,
//         pageDots: false,
//         groupCells: true,
//         cellAlign: 'left'
//     });
// });



// WEBPACK FOOTER //
// ../modules/Casestudies/assets/scripts/main.js